import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import EnteteDetails from './EnteteDetails';
import InformationsProduit from './InformationsProduit';
import { getProduit } from 'data/produits';

const DetailsProduit = () => {
  const idProduit = useParams().idProduit;
  const [produit, setProduit] = useState({});
  useEffect(() => {
    const recupInfosProduit = async () => {
      const produitDetails = await getProduit(idProduit);
      console.log(produitDetails);
      setProduit(produitDetails[0]);
    };
    recupInfosProduit();
  }, [idProduit]);

  return (
    <>
      <Row>
        <EnteteDetails produit={produit} />
      </Row>
      <Row className="mt-3">
        <InformationsProduit produit={produit} />
      </Row>
    </>
  );
};

export default DetailsProduit;
